import { Text, TextProps } from "@mantine/core";

export const WorkBoxTitle = ({ children, color }: TextProps) => {
  return (
    <Text color={color} size="xs">
      {children}
    </Text>
  );
};
